<template>
  <div class="m-panel">
      <div class="m-panel-bar">
          <div class="m-panel-bar-title">
              {{title}}
          </div>
      </div>
      <div class="m-panel-body">
        <div class="base-box">
          <div class="base-item" v-for="item in list1">
            <div class="base-img"><img src="@/assets/images/menu-yw.png" alt="" /></div>
            <div class="base-text">
              <div>{{item.text}}</div>
              <div><i>{{item.num}}</i></div>
            </div>
          </div>
        </div>
        <div class="center-box">
          <div class="center-item" v-for="item in list2" :key="item.title">
            <div class="title">{{item.title}}</div>
            <div class="num">{{item.num}}</div>
            <div class="hb" :style="{color: item.hb<1?'red':'yellowgreen'}">{{ $t('环比') }}{{item.hb<1?'-'+item.hb*100:'+'+item.hb*100}}%</div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import {
    postAction
  } from '@/api/manage'
  export default{
    data(){
      return{
        title: this.$t('基本指标'),
        url: {
          queryBasicInformation: "/jeecg-engineering/ticket/index/largeScreen/queryBasicInformation",
          queryHomeIndexDisposeNum: "/jeecg-engineering/ticket/tickets/queryHomeIndexDisposeNum",
        },
        list1:[
          {text:this.$t('本月工单(件)'),num:0},
          {text:this.$t('本周工单(件)'),num:0},
          {text:this.$t('昨日工单(件)'),num:0},
          {text:this.$t('待处理工单(件)'),num:0},
        ],
        list2: [
          {title:this.$t('本年工单总数'),num:0,hb:0},
          {title:this.$t('本年已完成'),num:0,hb:0},
          {title:this.$t('本年未完成'),num:0,hb:0},
          {title:this.$t('本年超时未完成'),num:0,hb:0},
          {title:this.$t('本年工单完成率'),num:0,hb:0},
        ]
      }
    },
    methods:{
      init(){
        this.getData1();
        this.getData();
      },
      getData1(){
        postAction(this.url.queryBasicInformation,{}).then(res=>{
          if(res.success){
            var data = res.result;
            this.list1[0].num = data.monthTicketsNum;
            this.list1[1].num = data.weekTicketsNum;
            this.list1[2].num = data.lastDayTicketsNum;
            this.list1[3].num = data.toTicketsNum;
          }
        })
      },
      getData(){
        postAction(this.url.queryHomeIndexDisposeNum,{queryType:3}).then(res=>{
          if(res.success){
            var data = res.result;
            this.list2[0].num = data.ticketsNum;
            this.list2[1].num = data.finishTicketsNum;
            this.list2[2].num = data.unFinishTicketsNum;
            this.list2[3].num = data.timeOutTicketsNum;
            this.list2[4].num = (data.ticketsFinishRatio*100).toFixed(2)+'%';
            
            this.list2[0].hb = data.comparableMessage.ticketsRate;
            this.list2[1].hb = data.comparableMessage.finishRate;
            this.list2[2].hb = data.comparableMessage.unFinishRate;
            this.list2[3].hb = data.comparableMessage.timeoutUnFinishRate;
            this.list2[4].hb = data.comparableMessage.ticketsFinishRate;
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .base-box{
    display: flex;
    justify-content: space-evenly;
    height: 40%;
    .base-item{
      display: flex;
      align-items: center;
      width: 20%;
      height: 80%;
      .base-img{
        width: 50px;
        height: 50px;
        margin-right: 25px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .base-text{
        color: #fff;
        font-size: 15px;
        i{
          font-size: 25px;
        }
      }
    }
  }
  .center-box{
    display: flex;
    justify-content: space-evenly;
    .center-item{
      width: 18%;
      text-align: center;
      border: 1px solid #00FAFE;
      padding: 20px 10px;
      border-radius: 2px;
      .title{
        font-size: 20px;
        color: aqua;
      }
      .hb{
        font-size: 14px;
        color: yellowgreen;
      }
      .num{
        font-family: 'ds-digital-bold';
        color: #fff;
        font-size: 35px;
      }
    }
  }
  .center-content{
    height: 100%;
    padding: 10px;
    
  }
</style>